module.exports = __webpack_public_path__ + "static/img/satanizador-1.f5dc3f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/satanizador-1.jpg
// module id = NucY
// module chunks = 1